<template lang="pug" src="./custom-home-tech.pug"></template>

<script>
export default {
  data () {
    return {
      showLogos: false
    }
  },
  props: ['props'],
  methods: {
    onWaypoint ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.showLogos = true
      }
    },
    goToTech () {
      this.$router.push('/why-choose-us')
      setTimeout(() => {
        this.$scrollTo('#tech', { offset: -75 })
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-tech/custom-home-tech.vue